import RpmDataTable from "./RpmDataTable"

export default  RpmDataTable;



// WEBPACK FOOTER //
// ./src/components/App/ClientListWithMap/ClientDetail/QuickFocus/RpmDataModal/RpmDataTable/index.js